import styled from 'styled-components';
import React, { Component } from 'react';
import ScoreVisualizer from '../../../ui/score/ScoreVisualizer';
import { Localize } from '../../../locale/localization';

const Container = styled.div`
  display: flex;
`;

const Text = styled.div`
  flex: 5;
  p {
    margin-top: 1.5rem;
    margin-bottom: 0;
  }
  span {
    display: block;
  }
`;

const Score = styled.div`
  flex: 1;
  margin-top: -2rem;
  margin-bottom: -2rem;

  &.total {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }
`;

class PrizeTeamBonus extends Component {
  render() {
    const score = Math.round(this.props.score);
    const { showTotal, showScore, count } = this.props;

    return (
      <Container>
        <Text>
          <h2>{Localize('prize.bonus')}</h2>
          <p>
            {showScore && score + ' ' + Localize('prize.bonus.score')}
            {showTotal && <span>Paketteja myyty {count} kpl (1 pakettimyynti = 1 euroa)</span>}
          </p>
        </Text>
        {showScore && (
          <Score className={showTotal ? 'total' : ''}>
            <ScoreVisualizer tight percent={50} score={score} />
          </Score>
        )}
      </Container>
    );
  }
}

export default PrizeTeamBonus;



// WEBPACK FOOTER //
// ./src/modules/prize/components/PrizeTeamBonus.js